import { Button, message } from "antd";
import { FormEvent } from "react";
import { createPOF } from "../../../apis/misc.api";
import { usePermissions } from "../../../custom_hooks/permission/permission_hook";

export interface AttachLRDrawerProps {
  delivery: any;
  onClose: () => void;
}

export function AttachLRDrawer({ delivery, onClose }: AttachLRDrawerProps) {
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission("delivery.update");
  const onSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    if (!canEdit) {
      message.error("You don't have permission to attach LR");
      return;
    }

    const formData = new FormData(ev.currentTarget);
    const files = formData.getAll('proof_files');
    if (files.length === 0) {
      message.error("Please select a file");
      return;
    }
    formData.append('po_delivery_id', delivery.id.toString());
    formData.append('fullfillment_type', 'LR');

    const result = await createPOF(formData);

    if (result) {
      message.success("LR attached successfully");

      // Close the drawer
      onClose();
    } else {
      message.error("Failed to attach LR");
    }
  };

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="mb-3">
          <input type="file" name="proof_files" id="proof_files"
            className="form-control"/>
        </div>
        <Button htmlType="submit" type="primary" disabled={!canEdit} style={{ backgroundColor: '#ff69b4', borderColor: '#ff69b4' }}>
          Submit
        </Button>
      </form>
    </div>
  );
}